module.exports = __webpack_public_path__ + "img/brand3.36ddcdcd.png";